import * as React from 'react';
import { FC } from 'react';
import Button from '@mui/material/Button';
import styled from '@emotion/styled';
import FilterControlsContainerStyle from './FilterControls.mock';
import { FilterControlsInterface } from './FilterControls.interface';
import { LABEL_CLEAR } from '../Filter.mock';

const FilterControlsContainer = styled.div(FilterControlsContainerStyle);

const StyledButtonFilterControl = styled(Button)`
  padding: 0.5rem 2rem;
`;

const FilterControls: FC<FilterControlsInterface> = ({ controls }) => {
  return (
    <FilterControlsContainer>
      {controls.map(({ label, onAction, isAble }) => {
        return (
          <StyledButtonFilterControl
            variant={label === LABEL_CLEAR ? 'outlined' : 'contained'}
            id={label}
            onClick={onAction}
            key={label}
            disabled={!isAble}
          >
            {label}
          </StyledButtonFilterControl>
        );
      })}
    </FilterControlsContainer>
  );
};

export default FilterControls;
